import { render, staticRenderFns } from "./OpenVip.vue?vue&type=template&id=12d62a5c&scoped=true&"
import script from "./OpenVip.vue?vue&type=script&lang=js&"
export * from "./OpenVip.vue?vue&type=script&lang=js&"
import style0 from "./OpenVip.vue?vue&type=style&index=0&id=12d62a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d62a5c",
  null
  
)

export default component.exports